import { DistributionChannel } from "@deliverr/replenishment-client";

export const ReplenishmentConstants: {
  MAX_PRODUCT_LIMIT: number;
  MAX_PO_NUMBER_LENGTH: number;
  SUPPORTED_EACH_PICK_CHANNELS: readonly DistributionChannel[];
  ECOM_CHANNELS: readonly DistributionChannel[];
} = {
  MAX_PRODUCT_LIMIT: 500,
  MAX_PO_NUMBER_LENGTH: 100,
  SUPPORTED_EACH_PICK_CHANNELS: [
    DistributionChannel.WHOLESALE,
    DistributionChannel.ECOM_VIA_CROSSDOCK,
    DistributionChannel.ECOM_DIRECT_TO_FC,
  ],
  ECOM_CHANNELS: [
    DistributionChannel.ECOM_VIA_CROSSDOCK,
    DistributionChannel.ECOM_DIRECT_TO_FC,
    DistributionChannel.ECOM_VIA_HUB,
  ],
} as const;
